
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clause-privacy",
      function () {
        return require("private-next-pages/clause-privacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clause-privacy"])
      });
    }
  